// 結合
// const S3_FW_BUCKET_NAME = "ls-cloud-gwfw-dev";
// 検証
//const S3_FW_BUCKET_NAME = "ls-cloud-gwfw-stg";
// 商用
const S3_FW_BUCKET_NAME = "ls-cloud-gwfw-prd";
export default S3_FW_BUCKET_NAME;
